<template>
  <div>
    <table ref="table" class="display table table-hover table-striped" style="width:100%">
      <thead>
        <tr>
          <th v-for="(col, index) in columns" :key="index" :style="'text-align: ' + col.align">
            {{ col.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rIndex) in data" :key="rIndex">
          <td v-for="(col, cIndex) in columns" :key="cIndex" :style="'text-align: ' + col.align">
            {{ row[col.field] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';

export default {
  name: 'DataTable',
  props: {
    data: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    sort: {
      type: String,
      required: true
    },
    sortcolumn: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dataTableInstance: null
    };
  },
  mounted() {
    this.initDataTable();
  },
  watch: {
    data: {
      handler() {
        this.reloadDataTable();
      },
      deep: true
    }
  },
  methods: {
    initDataTable() {
      this.$nextTick(() => {
        if ($.fn.DataTable.isDataTable(this.$refs.table)) {
          $(this.$refs.table).DataTable().clear().destroy(); // limpa e destrói
        }
        this.dataTableInstance = $(this.$refs.table).DataTable({
          order: [[this.sortcolumn, this.sort]], // define ordenação
          language: {
            "sEmptyTable": "Nenhum dado disponível na tabela",
            "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
            "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
            "sInfoFiltered": "(filtrado de _MAX_ registros no total)",
            "sLengthMenu": "Mostrar _MENU_ registros",
            "sLoadingRecords": "Carregando...",
            "sProcessing": "Processando...",
            "sSearch": "Buscar:",
            "sZeroRecords": "Nenhum registro correspondente encontrado",
            "oPaginate": {
              "sFirst": "Primeiro",
              "sLast": "Último",
              "sNext": "Próximo",
              "sPrevious": "Anterior"
            },
            "oAria": {
              "sSortAscending": ": ativar para ordenar a coluna em ordem crescente",
              "sSortDescending": ": ativar para ordenar a coluna em ordem decrescente"
            }
          }
        });
      });
    },
    reloadDataTable() {
      if (this.dataTableInstance) {
        this.dataTableInstance.clear().destroy();
        this.dataTableInstance = null;
      }
      this.initDataTable();
    }
  }
};
</script>


<style scoped>
/* Estilo opcional */
</style>
